import Vue from 'vue'
import Vuex from 'vuex'

import me from './me'
import ui from './ui'
import offer from './offer'
import category from './category'
import retailer from './retailer'
import providers from './providers'
import apiKeys from './api-keys'
import dashboard from './dashboard'
import offerGroup from './offer-group'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    me,
    ui,
    offer,
    category,
    retailer,
    providers,
    apiKeys,
    dashboard,
    offerGroup,
  },
})
